<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="sampleCode"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayName="{ row }">
        <span>NO：{{ row.sampleStyleNo }}</span>
        <br />
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:specInfo="{ row }">
        {{ row.sampleSpec }} {{ row.v_sampleSizeUnit }}
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:costPrice="{ row }">
        <span>{{ row.costPrice }} {{ row.costCurrency || '' }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:quotedMethod="{ row }">
        <span>{{ row.quotedPrice }} {{ row.quotedCurrency || '' }}</span>
        <br />
        <span>{{ row.quotedMethod }}</span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
          @click="onImagePreview(row.defaultImageUrl)"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.sampleStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.sampleStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:detailOpt="{ row }">
        <div
          style="display: flex;justify-items: center;align-items: center;"
          @click="optCommand({ opt: { menuType: 'detail' }, data: row })"
        >
          <i class="el-icon-view tool-btn"></i>
          {{ '查看' }}
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImage"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      updateSalePersonVisible: false,
      salesPersonForm: {},
      listImage: [],
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    tableColumns() {
      return tableColumns(this, this.disabled)
    },
  },
  activated() {},
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { sampleCode } = data

      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'submitEdit':
          this.$emit('openEditPage', {
            pageType: menuType,
            sampleCode,
          })
          break
        case 'copy':
          this.copy(data)
          break
        case 'delete':
          this.del(data)
          break
        case 'submit':
          this.audit(data)
          break
        case 'reduction':
          this.reduction(data)
          break
        case 'reject':
          this.reject(data)
          break
      }
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.vxeGrid.clearCheckboxRow()
      this.$refs.vxeGrid.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },

    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.vxeGrid
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true)
      const reserves = $table.getCheckboxReserveRecords(true)
      this.$emit('checkboxChange', data.concat(reserves))
    },
    onImagePreview(defaultImageUrl) {
      this.listImage = [defaultImageUrl]
      // 点击大图显示图片预览组件
      this.viewer = this.$el.querySelector('.imagesViewer').$viewer
      this.viewer.view(0)
      this.viewer.show()
    },
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$api.sampleInfoDelApi({ sampleCode: row.sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('setSampleReload')
          this.clearCheckboxRow()
        })
      })
    },
    reduction(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_reduction') || '是否要还原该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$api
          .sampleInfoReductionApi({ sampleCode: row.sampleCode })
          .then(() => {
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.form_label_reduction_succeeded') || '还原成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    copy(row) {
      this.$confirm(
        this.$l('INDEX.tips_copy') || '是否要复制该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$api
          .sampleSetInfoCopyDetailApi({
            sampleCode: row.sampleCode,
            inputSource: 'PC',
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            this.$emit('setSampleReload')
          })
      })
    },
    audit(row) {
      this.$confirm(
        this.$l('INDEX.tips_audit') || '是否要审核该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.sampleInfoAudi(row.sampleCode)
      })
    },
    sampleInfoAudi(sampleCode) {
      this.$api.sampleInfoAuditApi({ sampleCode }).then(() => {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    reject({ sampleCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_reject') || '是否驳回该审核请求？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .sampleInfoRejectApi({ sampleCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error('驳回失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '驳回成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
